import adminLayout from '@/admin/layouts/LayoutOne.vue'

export default [
    {
        path: '/admin/dashboard/news-portal/divisions',
        name: 'DivisionModule',
        component: () => import('@/admin/modules/news-portal/DivisionModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/dashboard/news-portal/categories',
        name: 'CategoryModule',
        component: () => import('@/admin/modules/news-portal/CategoryModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/dashboard/news-portal/journalists',
        name: 'JournalistModule',
        component: () => import('@/admin/modules/news-portal/JournalistModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    },
    {
        path: '/admin/dashboard/news-portal/news',
        name: 'NewsModule',
        component: () => import('@/admin/modules/news-portal/NewsModule'),
        meta: { layout: adminLayout, requiresAuth:true }
    }
];